import React, { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { getAdminProfile } from "../../../../services/authService";

import {
  User,
  Building,
  Plus,
  Trash2,
  Calendar,
  Layers,
  Sparkles,
  CreditCard,
  DollarSign,
  Globe,
  CheckCircle2,
  HelpCircle,
  X,
  TriangleAlert,
  Loader2,
  FilePenLine,
  XCircle,
  AlertCircle,
} from "lucide-react";
import { useEffect } from "react";
import PreviewSoftwareQuotation from "./PreviewSoftwareQuotation";
import {
  fetchAllServices,
  fetchPackages,
  getSoftwareTypes,
} from "../../../../services/apiService";
import { useCallback } from "react";
import AmountMismatchAlert from "./AmountMismatchAlert";
import { viewSoftwareQuotation } from "../../../../services/quotationService";
import SoftwareQuotationReport from "./SoftwareQuotationReport";

export default function GenerateQuotationSoftware() {
  const [profileData, setProfileData] = useState(null);
  const [clientName, setClientName] = useState("");
  const [softwareType, setSoftwareType] = useState("");

  const [idsPayIntegration, setIdsPayIntegration] = useState("no");
  const [idsApi, setIdsApi] = useState("");
  const [idsPackage, setIdsPackage] = useState("");

  const [thirdPartyIntegration, setThirdPartyIntegration] = useState("no");
  const [thirdPartyApis, setThirdPartyApis] = useState([
    {
      apiName: "",
      amount: "",
    },
  ]);

  const [searchInput, setSearchInput] = useState(null);

  const loginOptions = [
    "Admin Login",
    "Sub Admin",
    "Branch",
    "Agent Web Login",
    "Agent Android Web App",
    "Customer Login",
    "User Panel",
    "Website",
    "Customer Android Web App",
  ];
  const [selectedLogins, setSelectedLogins] = useState([]);

  // Financials & AMC
  const [softwareCost, setSoftwareCost] = useState("");
  const [idsPayCost, setIdsPayCost] = useState("");
  const [thirdPartyCost, setThirdPartyCost] = useState("");
  const [discount, setDiscount] = useState("");
  const [amcCost, setAmcCost] = useState("");

  // Date & Domain
  const [deliveryDate, setDeliveryDate] = useState("");
  const [domainManagedBy, setDomainManagedBy] = useState("IDSPay");
  const [quotationDate, setQuotationDate] = useState(
    new Date().toISOString().split("T")[0],
  );

  const [page, setPage] = useState(1);
  const [service, setService] = useState([]);
  const [packages, setPackages] = useState([]);
  const [selectedService, setSelectedService] = useState("");
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [serviceLoading, setServiceLoading] = useState(false);
  const [packageLoading, setPackageLoading] = useState(false);

  const [showPreview, setShowPreview] = useState(false);
  const [previewData, setPreviewData] = useState({});
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [quotationReport, setQuotationReport] = useState([]);
  const [fetchNewQuotation, setFetchNewQuotation] = useState(true)

  // Payment Breakdown Dynamics
  const [paymentModes, setPaymentModes] = useState([
    { remark: "Advance Payment", amount: "" },
  ]);

  const [totalCostWithDiscount, setTotalCostWithDiscount] = useState(0);
  const [paymodeSum, setPaymodeSum] = useState(0);
  const [finalAmountError, setFinalAmountError] = useState("");

  // Quill Editor State
  const [quillContent, setQuillContent] = useState(null);

  // this is for IDSPay service name, charge, and fee
  const [selectedServicesAndPackages, setSelectedServicesAndPackages] =
    useState([]);

  // --- UI Handlers ---
  const toggleLoginType = (option) => {
    setSelectedLogins((prev) =>
      prev.includes(option)
        ? prev.filter((item) => item !== option)
        : [...prev, option],
    );
  };

  const handleSelectService = (item) => {
    setSelectedServicesAndPackages((prev) => [
      ...prev,
      {
        service: item,
        charge: null,
        fee: null,
      },
    ]);
  };

  const handleSelectPackage = (item) => {
    setSelectedServicesAndPackages((prev) => {
      if (prev.length === 0) return prev;

      const updated = [...prev];

      const lastIndex = updated.length - 1;

      updated[lastIndex] = {
        ...updated[lastIndex],
        charge: item?.charge?.amount.toFixed(2) || "N/A",
      };

      return updated;
    });
  };

  const handleAddFee = (e, index) => {
    setSelectedServicesAndPackages((prev) => {
      if (prev.length === 0) return prev;

      let idx = index;
      const updated = [...prev];
      updated[idx] = { ...updated[idx], fee: e.target.value || "" };

      return updated;
    });
  };

  const handleGenerateQuotation = () => {
    const data = {};

    // 1. Client & General Details
    if (clientName) data.clientName = clientName;
    if (softwareType) data.softwareType = softwareType;
    if (quotationDate) data.quotationDate = quotationDate;
    if (domainManagedBy) data.domainManagedBy = domainManagedBy;
    if (deliveryDate) data.deliveryDate = deliveryDate;

    // 2. IDSPay Integration Data
    data.idsPayIntegration = idsPayIntegration;
    data.idsPayIntegration = idsPayIntegration;
    if (idsPayIntegration === "yes") {
      if (selectedServicesAndPackages)
        data.idsApi = selectedServicesAndPackages;
      if (idsPayCost) data.idsPayCost = idsPayCost;
    }

    // 3. Third-Party Integration Data
    data.thirdPartyIntegration = thirdPartyIntegration;

    data.thirdPartyIntegration = thirdPartyIntegration;
    if (thirdPartyIntegration === "yes") {
      // Filter out any accidentally blank inputs
      if (thirdPartyApis.length > 0) data.thirdPartyApis = thirdPartyApis;
      if (thirdPartyCost) data.thirdPartyCost = thirdPartyCost;
    }

    // 4. Login Types Multi-select
    if (selectedLogins.length > 0) data.selectedLogins = selectedLogins;

    // 5. Cost & Maintenance
    if (softwareCost) data.softwareCost = softwareCost;
    if (discount) data.discount = discount;
    if (amcCost) data.amcCost = amcCost;

    // 6. Payment Modes (Filter out completely blank milestone rows)
    const validPayments = paymentModes.filter(
      (payment) =>
        payment.remark.trim() !== "" || payment.amount.toString().trim() !== "",
    );
    if (validPayments.length > 0) data.paymentModes = validPayments;

    // 7. Terms & Proposal Editor Content
    if (quillContent) data.quillContent = quillContent;

    // Finalize Payload
    setPreviewData(data);
    setShowPreview(true);
  };

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;

    // user reached bottom
    if (scrollHeight - scrollTop <= clientHeight + 5) {
      getAllServices();
    }
  };

  const handleAddThirdPartyApi = () => {
    setThirdPartyApis([...thirdPartyApis, { apiName: "", amount: "" }]);
  };

  const handleThirdPartyApiChange = (index, field, value) => {
    const updated = [...thirdPartyApis];
    updated[index][field] = value;
    setThirdPartyApis(updated);
  };

  const handleRemoveThirdPartyApi = (index) => {
    setThirdPartyApis(thirdPartyApis.filter((_, i) => i !== index));
  };

  const handleAddPaymentMode = () => {
    setPaymentModes([...paymentModes, { remark: "", amount: "" }]);
  };

  const handlePaymentModeChange = (index, field, value) => {
    const updated = [...paymentModes];
    updated[index][field] = value;
    setPaymentModes(updated);
  };

  const handleRemovePaymentMode = (index) => {
    setPaymentModes(paymentModes.filter((_, i) => i !== index));
  };

  // api handlers

  const getAllServices = async () => {
    setServiceLoading(true);
    try {
      const res = await fetchAllServices({ page: page + 1 });

      if (res.status?.code === 200) {
        const { data, pagination } = res;
        setService((prev) => [...prev, ...res.data]);
        setPage((prev) => prev + 1);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setServiceLoading(false);
    }
  };

  const searchServices = async () => {
    setServiceLoading(true);
    try {
      const res = await fetchAllServices({ search: debouncedSearch });

      if (res.status?.code === 200) {
        setService(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setServiceLoading(false);
    }
  };

  const getPackages = async () => {
    setPackageLoading(true);
    try {
      const res = await fetchPackages({ service_id: selectedService?.id });

      if (res.status?.code === 200) {
        setPackages(res?.data);
      } else {
        setPackages([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setPackageLoading(false);
    }
  };

  const fetchProfile = async () => {
    try {
      const res = await getAdminProfile();
      if (res?.data?.user_id) {
        setProfileData(res?.data);
      }
    } catch (error) {
      console.error("Error fetching mobile number", error);
    }
  };

  const fetchQuotationReport = async () => {
    try {
      const res = await viewSoftwareQuotation();
      if (res?.status?.code === 200) {
        setQuotationReport(res?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const quotationError =
    selectedServicesAndPackages?.length > 0 &&
    selectedServicesAndPackages.some(
      (item) => item?.charge == null || item.charge === "",
    )
      ? "Please Select Charge For IDSPay API."
      : selectedServicesAndPackages?.length > 0 &&
          selectedServicesAndPackages.some(
            (item) => item?.fee == null || item.fee === "",
          )
        ? "Please enter Integration Fee for IDSPay API."
        : thirdPartyApis?.length > 0 &&
            thirdPartyApis[0]?.apiName !== "" &&
            thirdPartyApis.some((item) => item?.apiName?.trim() === "")
          ? "Please enter API name in third party API."
          : thirdPartyApis?.length > 0 &&
              thirdPartyApis[0]?.apiName !== "" &&
              thirdPartyApis.some(
                (item) => item?.amount == null || item.amount === "",
              )
            ? "Please enter Integration Fee for third party API."
            : "";

  const validQuotation =
    quotationError === "" &&
    clientName !== "" &&
    softwareType !== "" &&
    softwareCost !== "" &&
    quotationDate !== "" &&
    domainManagedBy !== "" &&
    selectedLogins !== [] &&
    amcCost !== "" &&
    deliveryDate !== "" &&
    paymentModes[0]?.amount !== "";

  useEffect(() => {
    console.log("callback running");

    const totalCost =
      Number(amcCost) +
      Number(thirdPartyCost) +
      Number(idsPayCost) +
      Number(softwareCost) -
      Number(discount);
    let payModeSumTotal = 0;

    if (paymentModes?.length > 0) {
      paymentModes?.forEach((item) => {
        payModeSumTotal = Number(item?.amount) + payModeSumTotal;
      });
    }

    if (Number(totalCost) !== Number(payModeSumTotal)) {
      setFinalAmountError(
        "Paymode Total not Matching All Fees of Software + APIs",
      );
    } else {
      setFinalAmountError("");
    }

    setPaymodeSum(Number(payModeSumTotal));
    setTotalCostWithDiscount(Number(totalCost));

    // console.log("total cost", totalCostWithDiscount);
    // console.log("paymode sum", paymodeSum);
  }, [
    amcCost,
    thirdPartyCost,
    idsPayCost,
    softwareCost,
    discount,
    paymentModes,
  ]);

  const validFinalAmount = finalAmountError === "";

  useEffect(() => {
    console.log("valid final Amount", validFinalAmount);
    console.log(" final Amount errrrr", finalAmountError);
  }, [finalAmountError, validFinalAmount]);

  // useEffect(() => {
  //   const fetchSoftares = async () => {
  //     try {
  //       const res = await getSoftwareTypes();

  //       if (res?.status?.code === 200) {
  //         console.log(res);
  //       }
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   };
  //   fetchSoftares();
  // }, []);

  useEffect(() => {
    searchServices();
  }, [debouncedSearch]);

  useEffect(() => {
    if (
      selectedServicesAndPackages?.length === 0 &&
      thirdPartyApis.length === 0
    )
      return;
    let sum = 0;
    let sum2 = 0;

    if (selectedServicesAndPackages?.length > 0) {
      selectedServicesAndPackages.forEach(
        (item) => (sum = sum + Number(item.fee)),
      );

      setIdsPayCost(sum);
    }

    if (thirdPartyApis.length > 0) {
      thirdPartyApis.forEach((item) => (sum2 = sum2 + Number(item.amount)));

      setThirdPartyCost(sum2);
    }
  }, [selectedServicesAndPackages, thirdPartyApis]);

  useEffect(() => {
    if (!selectedService?.id) return;

    getPackages();
  }, [selectedService?.id]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedSearch(searchInput);
    }, 500);

    return () => {
      clearTimeout(timeout);
    };
  }, [searchInput]);

  useEffect(() => {
    getAllServices();
    fetchProfile();
  }, []);

  useEffect(() => {
    if(!fetchNewQuotation) return
    fetchQuotationReport();
    
    const timeout = setTimeout(() => {
      setFetchNewQuotation(false)
    }, 5000);

    return (() => {
      clearTimeout(timeout)
    })
  }, [fetchNewQuotation]);

  useEffect(() => {
    console.log("selected  services and packages", selectedServicesAndPackages);
  }, [selectedServicesAndPackages]);

  return (
    <div>
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mt-2 items-start">
        {/* ================= LEFT SIDE: FORM ================= */}
        <div className="lg:col-span-5 space-y-6">
          {/* SECTION 1: Client & General Info */}
          <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
            <h3 className="text-lg font-bold text-slate-800 mb-4 flex items-center gap-2">
              <User className="h-5 w-5 text-blue-600" />
              Client & General Details
            </h3>

            <div className="grid grid-cols-1 gap-4">
              {/* Client Name */}
              <div>
                <label className="block text-xs font-semibold uppercase text-slate-500 mb-1">
                  Client Name <span className="text-red-700 text-sm">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Enter client full name"
                  value={clientName}
                  onChange={(e) => setClientName(e.target.value)}
                  className="w-full rounded-lg border border-slate-300 px-3.5 py-2.5 text-sm text-slate-800 transition focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/20"
                />
              </div>

              {/* Software Type */}
              <div>
                <label className="block text-xs font-semibold uppercase text-slate-500 mb-1">
                  Software Type <span className="text-red-700 text-sm">*</span>
                </label>
                <select
                  value={softwareType}
                  onChange={(e) => setSoftwareType(e.target.value)}
                  className="w-full rounded-lg border border-slate-300 px-3.5 py-2.5 text-sm text-slate-800 transition focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/20 bg-white"
                >
                  <option value="">Select Software Type</option>

                  <optgroup label="Banking Software">
                    <option value="Nidhi Banking Software">
                      Nidhi Banking Software
                    </option>
                    <option value="Nidhi Banking Software Standard">
                      Nidhi Banking Software Standard
                    </option>
                    <option value="Nidhi Banking Software Premium">
                      Nidhi Banking Software Premium
                    </option>
                    <option value="Core Nidhi Banking Software">
                      Core Nidhi Banking Software
                    </option>
                    <option value="Co-Operative Society Software">
                      Co-Operative Society Software
                    </option>
                  </optgroup>

                  <optgroup label="Deposits Software">
                    <option value="Daily Deposit Software">
                      Daily Deposit Software
                    </option>
                    <option value="Recurring Deposit Software">
                      Recurring Deposit Software
                    </option>
                    <option value="MIS Software">MIS Software</option>
                    <option value="Fixed Deposit Software">
                      Fixed Deposit Software
                    </option>
                  </optgroup>

                  <optgroup label="Finance & Lending Software">
                    <option value="Micro Finance Software">
                      Micro Finance Software
                    </option>
                    <option value="Micro Finance Software Standard">
                      Micro Finance Software Standard
                    </option>
                    <option value="Micro Finance Software Premium">
                      Micro Finance Software Premium
                    </option>
                    <option value="Gold Loan Software">
                      Gold Loan Software
                    </option>
                    <option value="Business Loan Software">
                      Business Loan Software
                    </option>
                    <option value="NBFC Software">NBFC Software</option>
                  </optgroup>

                  <optgroup label="Farmer Software">
                    <option value="Farmer Producer Company Software">
                      Farmer Producer Company Software
                    </option>
                  </optgroup>

                  <optgroup label="NGO & Non-Profit ORG Software">
                    <option value="NGO V1 Software">NGO V1 Software</option>
                    <option value="NGO V2 Software">NGO V2 Software</option>
                  </optgroup>

                  <optgroup label="Management & Collection Software">
                    <option value="CRM Software">CRM Software</option>
                    <option value="Loan Collection Software">
                      Loan Collection Software
                    </option>
                  </optgroup>

                  <optgroup label="Educational Software">
                    <option value="School Management Software">
                      School Management Software
                    </option>
                    <option value="Institute Management Software">
                      Institute Management Software
                    </option>
                    <option value="Library Management Software">
                      Library Management Software
                    </option>
                    <option value="College Management Software">
                      College Management Software
                    </option>
                    <option value="Hostel Management Software">
                      Hostel Management Software
                    </option>
                  </optgroup>

                  <optgroup label="Medical & Hospitality Software">
                    <option value="Path Lab Management Software">
                      Path Lab Management Software
                    </option>
                    <option value="Hospital Management Software">
                      Hospital Management Software
                    </option>
                  </optgroup>

                  <optgroup label="Website & Logo Designing">
                    <option value="Website Development">
                      Website Development
                    </option>
                    <option value="Logo Designing">Logo Designing</option>
                    <option value="3-D Logo Designing">
                      3-D Logo Designing
                    </option>
                  </optgroup>

                  <optgroup label="Custom Development">
                    <option value="Custom Software Development">
                      Custom Software Development
                    </option>
                    <option value="Recharge & BBPS Portal Development">
                      Recharge & BBPS Portal Development
                    </option>
                    <option value="Web Portal Development">
                      Web Portal Development
                    </option>
                  </optgroup>
                </select>
              </div>

              {/* Quotation Generation Date (Auto-filled) */}
              <div>
                <label className="block text-xs font-semibold uppercase text-slate-500 mb-1">
                  Quotation Date <span className="text-red-700 text-sm">*</span>
                </label>
                <input
                  type="date"
                  value={quotationDate}
                  onChange={(e) => setQuotationDate(e.target.value)}
                  className="w-full rounded-lg border border-slate-300 px-3.5 py-2.5 text-sm text-slate-800 "
                />
              </div>

              {/* Domain Provided & Managed By */}
              <div>
                <label className="block text-xs font-semibold uppercase text-slate-500 mb-1">
                  Domain Managed By{" "}
                  <span className="text-red-700 text-sm">*</span>
                </label>
                <select
                  value={domainManagedBy}
                  onChange={(e) => setDomainManagedBy(e.target.value)}
                  className="w-full rounded-lg border border-slate-300 px-3.5 py-2.5 text-sm text-slate-800 transition focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/20 bg-white"
                >
                  <option value="IDSPay">IDSPay</option>
                  <option value="By Client">By Client</option>
                </select>
              </div>
            </div>
          </div>

          {/* SECTION 2: API Integrations */}
          <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm space-y-6">
            <h3 className="text-lg font-bold text-slate-800 flex items-center gap-2">
              <Globe className="h-5 w-5 text-blue-600" />
              API Integrations
            </h3>

            {/* IDSPay API Integration */}
            <div className="border-b border-slate-100 pb-5">
              <label className="block text-sm font-semibold text-slate-700 mb-2">
                IDSPay API Integration?
              </label>
              <div className="flex gap-6 mb-3">
                <label className="flex items-center gap-2 text-sm text-slate-600 cursor-pointer">
                  <input
                    type="radio"
                    name="idsPayRadio"
                    value="yes"
                    checked={idsPayIntegration === "yes"}
                    onChange={() => setIdsPayIntegration("yes")}
                    className="h-4 w-4 text-blue-600 focus:ring-blue-500"
                  />
                  Yes
                </label>
                <label className="flex items-center gap-2 text-sm text-slate-600 cursor-pointer">
                  <input
                    type="radio"
                    name="idsPayRadio"
                    value="no"
                    checked={idsPayIntegration === "no"}
                    onChange={() => setIdsPayIntegration("no")}
                    className="h-4 w-4 text-blue-600 focus:ring-blue-500"
                  />
                  No
                </label>
              </div>

              {idsPayIntegration === "yes" && (
                <div className="grid grid-cols-1  gap-4 mt-3 bg-blue-50/50 p-4 rounded-xl border border-blue-100">
                  {/* <div>
                  <label className="block text-xs font-semibold text-slate-600 mb-1">
                    Select API
                  </label>
                  <select
                    value={idsApi}
                    onChange={(e) => setIdsApi(e.target.value)}
                    className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm bg-white focus:ring-2 focus:ring-blue-500/20"
                  >
                    <option value="">Choose API...</option>
                    <option value="recharge">Recharge API</option>
                    <option value="payout">Payout API</option>
                    <option value="aeps">AEPS API</option>
                  </select>
                </div> */}

                  {/* <div>
                  <label className="block text-xs font-semibold text-slate-600 mb-1">
                    Select Package
                  </label>
                  <select
                    value={idsPackage}
                    onChange={(e) => setIdsPackage(e.target.value)}
                    className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm bg-white focus:ring-2 focus:ring-blue-500/20"
                  >
                    <option value="">Choose Package...</option>
                    <option value="starter">Starter Package</option>
                    <option value="enterprise">Enterprise Package</option>
                  </select>
                </div> */}

                  <div>
                    <label className=" text-xs font-bold uppercase tracking-wider flex items-center justify-between text-slate-500 ">
                      <div>Search API Service </div>
                      <div className="">
                        <Loader2
                          size={24}
                          className={`text-green-600 animate-spin ${serviceLoading ? "opacity-100" : "opacity-0"}`}
                        />
                      </div>
                    </label>

                    <div>
                      <input
                        type="search"
                        value={searchInput}
                        placeholder="Search Here..."
                        onChange={(e) => setSearchInput(e.target.value)}
                        className="w-full placeholder:pl-3 my-2 py-2 px-3 bg-slate-50 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none transition"
                      />
                    </div>

                    {service?.length > 0 ? (
                      <div className="w-full p-3 bg-slate-50 border border-slate-300 rounded-lg outline-none">
                        {/* <option value="">Select Service</option> */}

                        {service?.length > 0 && (
                          <div
                            onScroll={handleScroll}
                            className="max-h-60 flex flex-col px-4 items-start gap-1 overflow-y-auto"
                          >
                            {service?.map((item, idx) => (
                              <div
                                key={idx}
                                onClick={() => {
                                  handleSelectService(item?.service_name);
                                  setSelectedService(item);
                                }}
                                className={`${selectedService?.service_code === item?.service_code ? "bg-blue-600 text-white" : ""} cursor-pointer py-1 w-full px-2 rounded-lg`}
                              >
                                {item?.service_name || "Not Found"}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    ) : (
                      <div className="w-full p-1 text-red-600 text-center rounded-lg outline-none flex items-center justify-center gap-3">
                        <TriangleAlert size={18} />
                        {searchInput} Not Found
                      </div>
                    )}
                  </div>

                  <div>
                    <label className=" flex items-end justify-start gap-2 text-xs font-bold uppercase tracking-wider text-slate-500 mb-2">
                      Select API Call Charge
                    </label>
                    <select
                      value={selectedPackage}
                      onChange={(e) => {
                        const packageId = e.target.value;

                        setSelectedPackage(packageId);

                        const selectedPackageItem = packages?.find(
                          (item) =>
                            String(item.package_id) === String(packageId),
                        );

                        if (selectedPackageItem) {
                          handleSelectPackage(selectedPackageItem);
                        }
                      }}
                      className="w-full p-3 bg-slate-50 border border-slate-300 rounded-lg outline-none "
                    >
                      {packageLoading && <option value="">Loading...</option>}
                      <option value="">Select Charge</option>
                      {packages?.map((item, idx) => (
                        <option key={idx} value={item.package_id}>
                          {item?.charge?.amount}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              )}
            </div>

            {/* Third Party API Integration */}
            <div>
              <label className="block text-sm font-semibold text-slate-700 mb-2">
                Third Party API Integration?
              </label>
              <div className="flex gap-6 mb-3">
                <label className="flex items-center gap-2 text-sm text-slate-600 cursor-pointer">
                  <input
                    type="radio"
                    name="thirdPartyRadio"
                    value="yes"
                    checked={thirdPartyIntegration === "yes"}
                    onChange={() => setThirdPartyIntegration("yes")}
                    className="h-4 w-4 text-blue-600 focus:ring-blue-500"
                  />
                  Yes
                </label>
                <label className="flex items-center gap-2 text-sm text-slate-600 cursor-pointer">
                  <input
                    type="radio"
                    name="thirdPartyRadio"
                    value="no"
                    checked={thirdPartyIntegration === "no"}
                    onChange={() => setThirdPartyIntegration("no")}
                    className="h-4 w-4 text-blue-600 focus:ring-blue-500"
                  />
                  No
                </label>
              </div>

              {thirdPartyIntegration === "yes" && (
                <div className="space-y-2 mt-3 bg-slate-50 p-4 rounded-xl border border-slate-200/80">
                  <div className="flex justify-between items-center">
                    <label className="block text-xs font-semibold text-slate-600 mb-1">
                      Add Service Name
                    </label>
                    <label className="block text-xs font-semibold text-slate-600 mb-1">
                      Integration Cost
                    </label>
                  </div>
                  {thirdPartyApis.map((api, index) => (
                    <div key={index} className="flex items-center gap-2">
                      <input
                        type="text"
                        placeholder={`Service Name`}
                        value={api.apiName}
                        onChange={(e) =>
                          handleThirdPartyApiChange(
                            index,
                            "apiName",
                            e.target.value,
                          )
                        }
                        className="w-48 rounded-lg border border-slate-300 px-3 py-2 text-sm bg-white focus:ring-2 focus:ring-blue-500/20"
                      />

                      <input
                        type="number"
                        placeholder="Cost (₹)"
                        value={api.amount}
                        onChange={(e) =>
                          handleThirdPartyApiChange(
                            index,
                            "amount",
                            e.target.value,
                          )
                        }
                        className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm bg-white focus:ring-2 focus:ring-blue-500/20"
                      />
                      {thirdPartyApis.length > 1 && (
                        <button
                          type="button"
                          onClick={() => handleRemoveThirdPartyApi(index)}
                          className="p-2 text-red-500 hover:bg-red-50 rounded-lg transition"
                        >
                          <Trash2 className="h-4 w-4" />
                        </button>
                      )}
                    </div>
                  ))}
                  <button
                    type="button"
                    onClick={handleAddThirdPartyApi}
                    className="mt-2 inline-flex items-center gap-1.5 text-xs font-semibold text-blue-600 hover:text-blue-700 hover:bg-blue-50 px-3 py-1.5 rounded-md transition"
                  >
                    <Plus className="h-3.5 w-3.5" /> Add Another API
                  </button>
                </div>
              )}
            </div>
          </div>

          {/* SECTION 3: Login Types Multi-Select */}
          <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
            <h3 className="text-lg font-bold text-slate-800 mb-1 flex items-center gap-2">
              <Layers className="h-5 w-5 text-blue-600" />
              Select Login Types <span className="text-red-700 text-sm">*</span>
            </h3>
            <p className="text-xs text-slate-500 mb-4">
              Click to select multiple portals/apps supported by this software.
            </p>

            <div className="flex flex-wrap gap-2">
              {loginOptions.map((option) => {
                const isSelected = selectedLogins.includes(option);
                return (
                  <button
                    key={option}
                    type="button"
                    onClick={() => toggleLoginType(option)}
                    className={`inline-flex items-center gap-1.5 rounded-full px-3.5 py-1.5 text-xs font-semibold transition-all ${
                      isSelected
                        ? "bg-blue-600 text-white shadow-sm ring-2 ring-blue-600/20"
                        : "bg-slate-100 text-slate-600 hover:bg-slate-200/70"
                    }`}
                  >
                    {isSelected && <CheckCircle2 className="h-3.5 w-3.5" />}
                    {option}
                  </button>
                );
              })}
            </div>
          </div>

          {/* SECTION 4: Cost & Pricing Breakdown */}
          <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
            <h3 className="text-lg font-bold text-slate-800 mb-4 flex items-center gap-2">
              <DollarSign className="h-5 w-5 text-blue-600" />
              Software Development Cost
            </h3>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {/* Software Cost */}
              <div>
                <label className="block text-xs font-semibold uppercase text-slate-500 mb-1">
                  Software Cost (₹){" "}
                  <span className="text-red-700 text-sm">*</span>
                </label>
                <input
                  type="number"
                  placeholder="0.00"
                  value={softwareCost}
                  onChange={(e) => setSoftwareCost(e.target.value)}
                  className="w-full rounded-lg border border-slate-300 px-3.5 py-2.5 text-sm text-slate-800 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20"
                />
              </div>

              {/* Conditional: IDSPay Cost */}
              {idsPayIntegration === "yes" && (
                <div>
                  <label className="block text-xs font-semibold uppercase text-slate-500 mb-1">
                    IDSPay API Integration Cost (₹)
                  </label>
                  <input
                    type="number"
                    placeholder="0.00"
                    value={idsPayCost}
                    onChange={(e) => setIdsPayCost(e.target.value)}
                    className="w-full rounded-lg border border-blue-200 bg-blue-50/30 px-3.5 py-2.5 text-sm text-slate-800 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20"
                  />
                </div>
              )}

              {/* Conditional: Third Party Cost */}
              {thirdPartyIntegration === "yes" && (
                <div>
                  <label className="block text-xs font-semibold uppercase text-slate-500 mb-1">
                    3rd Party API Integration Cost (₹)
                  </label>
                  <input
                    type="number"
                    placeholder="0.00"
                    value={thirdPartyCost}
                    onChange={(e) => setThirdPartyCost(e.target.value)}
                    className="w-full rounded-lg border border-blue-200 bg-blue-50/30 px-3.5 py-2.5 text-sm text-slate-800 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20"
                  />
                </div>
              )}

              {/* Discount */}
              <div>
                <label className="block text-xs font-semibold uppercase text-slate-500 mb-1">
                  Discount Applicable (₹)
                </label>
                <input
                  type="number"
                  placeholder="0.00"
                  value={discount}
                  onChange={(e) => setDiscount(e.target.value)}
                  className="w-full rounded-lg border border-slate-300 px-3.5 py-2.5 text-sm text-slate-800 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20"
                />
              </div>

              {/* AMC */}
              <div>
                <label className="block text-xs font-semibold uppercase text-slate-500 mb-1">
                  Annual Maintenance Cost (AMC){" "}
                  <span className="text-red-700 text-sm">*</span>
                </label>
                <input
                  type="number"
                  placeholder="0.00"
                  value={amcCost}
                  onChange={(e) => setAmcCost(e.target.value)}
                  className="w-full rounded-lg border border-slate-300 px-3.5 py-2.5 text-sm text-slate-800 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20"
                />
              </div>

              {/* Delivery Date */}
              <div className="sm:col-span-2">
                <label className="block text-xs font-semibold uppercase text-slate-500 mb-1">
                  Software Delivery Date{" "}
                  <span className="text-red-700 text-sm">*</span>
                </label>
                <input
                  type="date"
                  min={quotationDate}
                  value={deliveryDate}
                  onChange={(e) => setDeliveryDate(e.target.value)}
                  className="w-full rounded-lg border border-slate-300 px-3.5 py-2.5 text-sm text-slate-800 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20"
                />
                <p className="mt-1 flex items-center gap-1 text-[12px] text-amber-800 font-medium">
                  <HelpCircle className="h-3 w-3" />
                  Instruction: Select as per working day only.
                </p>
              </div>
            </div>
          </div>

          {/* SECTION 5: Dynamic Payment Modes */}
          <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-bold text-slate-800 flex items-center gap-2">
                <CreditCard className="h-5 w-5 text-blue-600" />
                Payment Pay Term <span className="text-red-700 text-sm">*</span>
              </h3>
              <button
                type="button"
                onClick={handleAddPaymentMode}
                className="inline-flex items-center gap-1 text-xs font-bold text-blue-600 bg-blue-50 hover:bg-blue-100 px-3 py-1.5 rounded-lg transition"
              >
                <Plus className="h-3.5 w-3.5" /> Add Installment
              </button>
            </div>
            <div className="space-y-3">
              {paymentModes.map((item, index) => (
                <div
                  key={index}
                  className="flex items-center gap-3 bg-slate-50 "
                >
                  <input
                    type="text"
                    placeholder="Remarks (e.g. 50% Advance)"
                    value={item.remark}
                    onChange={(e) =>
                      handlePaymentModeChange(index, "remark", e.target.value)
                    }
                    className="w-48 rounded-lg border border-slate-300 px-3 py-2 text-sm bg-white focus:ring-2 focus:ring-blue-500/20"
                  />
                  <input
                    type="number"
                    placeholder="Amount (₹)"
                    value={item.amount}
                    onChange={(e) =>
                      handlePaymentModeChange(index, "amount", e.target.value)
                    }
                    className="w-32 rounded-lg border border-slate-300 px-3 py-2 text-sm bg-white focus:ring-2 focus:ring-blue-500/20"
                  />
                  {paymentModes.length > 1 && (
                    <button
                      type="button"
                      onClick={() => handleRemovePaymentMode(index)}
                      className="p-2 text-red-500 hover:bg-red-50 rounded-lg transition"
                    >
                      <Trash2 className="h-4 w-4" />
                    </button>
                  )}
                </div>
              ))}
            </div>
            {finalAmountError && (
              <AmountMismatchAlert
                finalAmountError={finalAmountError}
                paymodeSum={paymodeSum}
                totalCostWithDiscount={totalCostWithDiscount}
              />
            )}{" "}
          </div>
        </div>

        {/* ================= RIGHT SIDE: REACT QUILL EDITOR ================= */}
        <div className="lg:col-span-7 sticky top-6 self-start">
          <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm space-y-4">
            <div className="flex items-center justify-between border-b border-slate-100 pb-3">
              <h3 className="text-lg font-bold text-slate-800 flex items-center gap-2">
                <FilePenLine className="h-5 w-5 text-blue-600" />
                Quotation Details and Feature Specification{" "}
                <span className="text-red-700 text-sm">*</span>
              </h3>
              <span className="text-xs bg-slate-100 text-slate-500 px-2.5 py-1 rounded-full font-medium">
                HTML Editor
              </span>
            </div>

            {/* Editor Container */}
            <div className="quill-wrapper border border-slate-200 rounded-xl overflow-hidden bg-white">
              <ReactQuill
                theme="snow"
                value={quillContent}
                onChange={setQuillContent}
                placeholder="Write quotation descriptions or additional terms here..."
                className="h-[420px]"
              />
            </div>
          </div>

          {selectedServicesAndPackages?.length > 0 && (
            <div className="mt-6">
              <div>
                <h3 className="text-sm font-semibold text-slate-800">
                  Selected IDSPay APIs Preview
                </h3>
              </div>

              <div className="mt-2 overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
                <table className="w-full text-sm">
                  <thead className="bg-slate-50 border-b border-slate-200">
                    <tr>
                      <th className="px-4 py-3 text-left font-semibold text-slate-600">
                        API Service Name
                      </th>

                      <th className="px-4 py-3 text-left font-semibold text-slate-600">
                        API Call Charge
                      </th>

                      <th className="px-4 py-3 text-right font-semibold text-slate-600">
                        Integration Fee
                      </th>

                      <th className="px-4 py-3 text-center font-semibold text-slate-600">
                        Action
                      </th>
                    </tr>
                  </thead>

                  <tbody className="divide-y divide-slate-100">
                    {selectedServicesAndPackages.map((item, index) => (
                      <tr
                        key={index}
                        className="transition-colors hover:bg-slate-50"
                      >
                        <td className="px-4 py-3 text-slate-800 font-medium">
                          {item?.service || "N/A"}
                        </td>

                        <td className="px-4 py-3 text-slate-600">
                          {item?.charge !== null && item?.charge !== undefined
                            ? Number(item.charge)
                            : "N/A"}
                        </td>

                        <td className="px-4 py-3 text-right font-semibold text-slate-800">
                          <div>
                            <input
                              type="number"
                              placeholder="0.00"
                              value={selectedServicesAndPackages[index]?.fee}
                              onChange={(e) => handleAddFee(e, index)}
                              className="w-full rounded-lg border border-slate-300 px-3.5 py-2.5 text-sm text-slate-800 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20"
                            />
                          </div>
                        </td>

                        <td className="px-4 py-3 text-center">
                          <button
                            type="button"
                            onClick={() => {
                              setSelectedServicesAndPackages((prev) =>
                                prev.filter((_, i) => i !== index),
                              );
                            }}
                            className="inline-flex items-center justify-center rounded-lg p-2 text-red-500 hover:bg-red-50 hover:text-red-600 transition"
                            title="Remove"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-5 w-5"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                              strokeWidth="2"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4V4a1 1 0 011-1h4a1 1 0 011 1v3m-7 0h10"
                              />
                            </svg>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {thirdPartyApis?.length > 0 && thirdPartyApis[0]?.apiName !== "" && (
            <div className="mt-12">
              <div>
                <h3 className="text-sm font-semibold text-slate-800">
                  Selected Third Party APIs Preview
                </h3>
              </div>
              <div className="mt-2 overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
                <table className="w-full text-sm">
                  <thead className="bg-slate-50 border-b border-slate-200">
                    <tr>
                      <th className="px-4 py-3 text-left font-semibold text-slate-600">
                        API Service Name
                      </th>

                      <th className="px-4 py-3 text-right font-semibold text-slate-600">
                        Integration Fee
                      </th>

                      <th className="px-4 py-3 text-center font-semibold text-slate-600">
                        Action
                      </th>
                    </tr>
                  </thead>

                  <tbody className="divide-y divide-slate-100">
                    {thirdPartyApis.map((api, index) => (
                      <tr
                        key={index}
                        className="hover:bg-slate-50 transition-colors"
                      >
                        <td className="px-4 py-3 font-medium text-slate-800">
                          {api?.apiName || "N/A"}
                        </td>

                        <td className="px-4 py-3 text-right font-semibold text-slate-800">
                          {api?.amount !== "" && api?.amount != null
                            ? Number(api.amount).toFixed(2)
                            : "N/A"}
                        </td>

                        <td className="px-4 py-3 text-center">
                          <button
                            type="button"
                            onClick={() => {
                              setThirdPartyApis((prev) =>
                                prev.filter((_, i) => i !== index),
                              );
                            }}
                            className="inline-flex items-center justify-center rounded-lg p-2 text-red-500 hover:bg-red-50 hover:text-red-600 transition"
                            title="Remove"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-5 w-5"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                              strokeWidth="2"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4V4a1 1 0 011-1h4a1 1 0 011 1v3m-7 0h10"
                              />
                            </svg>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          <div className="pt-10">
            <button
              disabled={!validQuotation || !validFinalAmount}
              onClick={handleGenerateQuotation}
              type="button"
              className="w-full rounded-xl disabled:opacity-50 bg-blue-600 py-3 text-sm font-bold text-white shadow-md hover:bg-blue-700 hover:shadow-lg transition-all"
            >
              Generate Software Quotation
            </button>

            {quotationError && (
              <div className="mt-2 flex items-center gap-2 rounded-lg bg-red-50 px-3 py-2 text-red-600 shadow-sm border border-red-300 transition-all animate-in fade-in slide-in-from-top-1">
                <AlertCircle
                  className="h-4 w-4 shrink-0 text-red-500"
                  strokeWidth={2.5}
                />
                <p className="text-sm font-medium">{quotationError}</p>
              </div>
            )}

            {finalAmountError && (
              <AmountMismatchAlert
                finalAmountError={finalAmountError}
                paymodeSum={paymodeSum}
                totalCostWithDiscount={totalCostWithDiscount}
              />
            )}
          </div>
        </div>

        {showPreview && (
          <div className="fixed z-[99] inset-0 w-full bg-black overflow-y-auto h-screen">
            <button
              onClick={() => setShowPreview(false)}
              className="fixed top-10 z-[999] right-6 text-white"
            >
              <X
                size={40}
                className="bg-red-50 text-red-700 rounded-full p-1"
              />
            </button>
            <PreviewSoftwareQuotation
              clientName={clientName}
              profileData={profileData}
              reportData={previewData}
            />
          </div>
        )}

      </div>
        <SoftwareQuotationReport setFetchAgain={() => setFetchNewQuotation(true)} reportData={quotationReport?.quotations} />
    </div>
  );
}
